export * from './file-drop.component'
export * from './file-drop.module'
export * from './upload-file.model'
export * from './upload-event.model'


// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/ngx-file-drop/lib/ngx-drop/index.ts